import { Component, OnInit, Inject } from '@angular/core';
import {DOCUMENT} from "@angular/platform-browser";
import { environment } from '../environments/environment';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  constructor(@Inject(DOCUMENT) private document) { }

  ngOnInit() {
    let bases = this.document.getElementsByTagName('base');
    
    if (bases.length > 0) {
      //bases[0].setAttribute('href', environment.baseHref);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts